import { useNavigate } from "react-router-dom";

import img from "./img/notfound.png";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const NotFound = () => {
    const navigation = useNavigate();

    const handleBack = () => {
        navigation("/");
    };

    return (
        <div className="not-found">
            <img src={img} className="not-found__img" />
            <span className="not-found__title">Что-то пошло не так</span>
            <span className="not-found__subtitle">К сожалению, эта страница отсутствует</span>
            <ButtonUI label="Вернуться на главную" onClick={handleBack} />
        </div>
    );
};

export default NotFound;
